import React from 'react';
import { Box, Select, TextInput } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';
import { useDynamicUI } from 'src/UI/dynamicUI/DynamicUiContext';
import { FinancialFormField } from 'src/financial/financial-data/financial-item/forms/common/FinancialFormField';

export function PercentageOrPoundField<T extends Record<string, unknown>>({
  fieldLabel,
  disabled,
  form,
  formFieldName,
  percentageOrPoundFieldName,
  index,
  product,
}: {
  fieldLabel?: string;
  disabled?: boolean;
  form: UseFormReturnType<T>;
  formFieldName: string;
  percentageOrPoundFieldName: string;
  index: number;
  product: string;
}) {
  const { isEditing, uiData } = useDynamicUI();
  const inputProps = form.getInputProps(`${product}.${index}.${formFieldName}`);
  const percentageOrPoundProps = form.getInputProps(
    `${product}.${index}.${percentageOrPoundFieldName}`,
  );
  const percentageOrPoundSelect = (
    <Box>
      <Select
        data={[
          { value: 'CURRENCY_AMOUNT', label: '£' },
          { value: 'PERCENTAGE', label: '%' },
        ]}
        defaultValue={'CURRENCY_AMOUNT'}
        styles={{
          input: { textAlign: 'left', padding: 0, paddingLeft: 10 },
        }}
        {...percentageOrPoundProps}
      />
    </Box>
  );

  const readProps: { readModePrepend?: string; readModeAppend?: string } = {};
  if (percentageOrPoundProps.defaultValue === 'CURRENCY_AMOUNT') {
    readProps.readModePrepend = '£';
  }

  if (percentageOrPoundProps.defaultValue === 'PERCENTAGE') {
    readProps.readModeAppend = '%';
  }

  const label = fieldLabel || uiData?.ui.entitiesMetadata[product][formFieldName]?.label;

  return isEditing ? (
    <TextInput
      key={form.key(`${formFieldName}.${index}`)}
      label={label}
      labelProps={{ variant: 'light' }}
      styles={{ input: { borderRight: '0px' }, section: { width: '70px' } }}
      type="number"
      rightSection={percentageOrPoundSelect}
      disabled={disabled}
      {...inputProps}
    />
  ) : (
    <FinancialFormField
      label={label}
      field={formFieldName}
      product={product}
      index={index}
      {...readProps}
    />
  );
}
